// extracted by mini-css-extract-plugin
export default {"addBtnIcon":"styles_addBtnIcon__qxmQq","add":"styles_add__ct2dp","animation":"styles_animation__rOBKk","popover":"styles_popover__+RPqk"};